module.exports = __webpack_public_path__ + "static/media/Banner.a58aed69.svg";